  
import Navbar from './Navbar.vue'

import Dashboard from './Dashboard.vue'


export { Navbar, Dashboard }


// WEBPACK FOOTER //
// ./src/pages/dashboard/index.js